import { render, staticRenderFns } from "./SignatureForm.vue?vue&type=template&id=dfda526a&"
import script from "./SignatureForm.vue?vue&type=script&lang=js&"
export * from "./SignatureForm.vue?vue&type=script&lang=js&"
import style0 from "./SignatureForm.vue?vue&type=style&index=0&id=dfda526a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports